var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNetworking = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 6,
  height: 6,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 16,
  width: 6,
  height: 6,
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 2,
  width: 6,
  height: 6,
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 12V8"
})));
export default SvgNetworking;